class ProductUSP extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Elemente erst nach DOM-Initialisierung suchen
    window.addEventListener('DOMContentLoaded', () => {
      this.infoButtons = this.querySelectorAll('.product-usp__info-button');
      this.details = this.querySelectorAll('.product-usp__details');
      this.setupEventListeners();
    });
  }

  setupEventListeners() {
    // Click Handler für Info-Buttons
    this.infoButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.stopPropagation(); // Verhindern, dass der Click ans Dokument weitergegeben wird
        this.toggleDetails(button);
      });
    });

    // Schließen beim Klick außerhalb
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeAllDetails();
      }
    });

    // Schließen mit Escape-Taste
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeAllDetails();
      }
    });
  }

  toggleDetails(button) {
    const detailsId = button.getAttribute('aria-controls');
    const details = document.getElementById(detailsId);
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    // Alle anderen Sprechblasen schließen
    this.closeAllDetails();

    if (!isExpanded && details) {
      // Diese Sprechblase öffnen
      button.setAttribute('aria-expanded', 'true');
      details.setAttribute('aria-hidden', 'false');
    }
  }

  closeAllDetails() {
    this.infoButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
    this.details.forEach(detail => {
      detail.setAttribute('aria-hidden', 'true');
    });
  }
}

// Custom Element registrieren
if (!customElements.get('product-usp')) {
  customElements.define('product-usp', ProductUSP);
}
